import { render } from "./TabbyNotes.vue?vue&type=template&id=5c79595a&scoped=true"
import script from "./TabbyNotes.vue?vue&type=script&lang=js"
export * from "./TabbyNotes.vue?vue&type=script&lang=js"

import "./TabbyNotes.vue?vue&type=style&index=0&id=5c79595a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5c79595a"

export default script